import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlterarSenhaModalComponent } from "./alterar-senha-modal.component";

@Injectable({
    providedIn: 'root'
})
export class AlterarSenhaModalService {

    constructor(private modalService: NgbModal) { }

    public abrirModal(): Promise<boolean> {
        const modalRef = this.modalService.open(AlterarSenhaModalComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });

        return modalRef.result;
    }
}
